export default __webpack_public_path__ + "static/media/Amila Agić.9543d4c6.jpg";